import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MetricData } from "../../types/Metric";

export interface MetricState {
    data: MetricData | undefined
    loading: boolean;
    error: boolean;
}

export const initialState: MetricState = {
    data: undefined,
    loading: true,
    error: false,
};

export const metricSlice = createSlice({
    name: "metric",
    initialState,
    reducers: {
        setData: (state, action: PayloadAction<MetricData | undefined>) => {
            state.data = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<boolean>) => {
            state.error = action.payload;
        },
    },
});

export const { setData, setLoading, setError } = metricSlice.actions;

export default metricSlice.reducer;
